import React from 'react';
import { Poppins } from 'src/common';
import { DashedContainer } from 'src/common/DashedContainer';

interface FrequencyIndicatorProps {
  times?: number | null;
  years?: number | null;
}

export const FrequencyIndicator: React.FC<FrequencyIndicatorProps> = ({ times, years }) => {
  const calculatePercentage = () => {
    if (!times || !years || years === 0) return 'N/A';
    const percentage = (times / years) * 100;
    const value = Math.round(percentage);
    return Math.max(0, Math.min(100, value));
  };

  return (
    <DashedContainer>
      <Poppins px={14} color="prussianBlue">
        <i>The expected chance to happen in the next year: {calculatePercentage()}%</i>
      </Poppins>
    </DashedContainer>
  );
};
